import React from 'react';

import MoreButton from '../MoreButton/MoreButton';
import { RailSettings } from '../RailProvider/types';

import styles from './Title.module.scss';

interface Props {
  railSettings: RailSettings;
  forwardHeaderRef: any;
  totalCount?: number;
  itemsLength: number;
  hasNextPage: boolean;
  isPossibleShowMore?: boolean;
}

const Title = ({ forwardHeaderRef, railSettings, totalCount, itemsLength, hasNextPage, isPossibleShowMore = true }: Props) => {
  const { title, moreLink } = railSettings;
  const shouldShowMoreButton = isPossibleShowMore && moreLink && !hasNextPage && itemsLength <= totalCount!; // temporary solution, will be removed after development
  // const shouldShowMoreButton = moreLink && !hasNextPage && itemsLength < totalCount;

  return (
    <>
      {title && (
        <div className={styles.header} ref={forwardHeaderRef}>
          <h2>
            {title}
          </h2>
          {shouldShowMoreButton && <MoreButton data={moreLink} />}
        </div>
      )}
    </>
  );
};

export default Title;
